module.exports = __webpack_public_path__ + "img/no-alerts.4db6d0b0.svg";